// Longitud máxima del número de una cuenta contable (AccountingAccount).
// Longitud exacta del número de una cuenta contable para que se pueda
// relacionar/asignar (AccountingAccountRelation).
export const ACCOUNT_MAX_CHAR = 46;

export const DEFAULT_OPTIONS = {
  ACCOUNT_TYPE: "ACTIVO_DEUDORA",
  CURRENCY: "PESO_MEXICANO",
  LEDGER_ACCOUNT: "NO",
  LAST_LEVEL: 0,
  AFFECTS_SPENDING: 0,
};

export const accountTypeOptions = [
  { label: "ACTIVO DEUDORA", value: "ACTIVO_DEUDORA" },
  { label: "ACTIVO ACREEDORA", value: "ACTIVO_ACREEDORA" },
  { label: "PASIVO DEUDORA", value: "PASIVO_DEUDORA" },
  { label: "PASIVO ACREEDORA", value: "PASIVO_ACREEDORA" },
  { label: "CAPITAL DEUDORA", value: "CAPITAL_DEUDORA" },
  { label: "CAPITAL ACREEDORA", value: "CAPITAL_ACREEDORA" },
  { label: "RESULTADOS DEUDORA", value: "RESULTADOS_DEUDORA" },
  { label: "RESULTADOS ACREEDORA", value: "RESULTADOS_ACREEDORA" },
  { label: "ESTADISTICA DEUDORA", value: "ESTADISTICA_DEUDORA" },
  { label: "ESTADISTICA ACREEDORA", value: "ESTADISTICA_ACREEDORA" },
  { label: "ORDEN DEUDORA", value: "ORDEN_DEUDORA" },
  { label: "ORDEN ACREEDORA", value: "ORDEN_ACREEDORA" },
  { label: "GASTO DEUDORA", value: "GASTO_DEUDORA" },
  { label: "INGRESO ACREEDORA", value: "INGRESO_ACREEDORA" },
];

export const ledgerAccountOptions = [
  { label: "SI", value: "SI" },
  { label: "NO", value: "NO" },
  { label: "DE TITULO", value: "DE_TITULO" },
  { label: "DE SUBTITULO", value: "DE_SUBTITULO" },
];

export const currencyOptions = [
  { label: "MXN", value: "PESO_MEXICANO" },
  { label: "USD", value: "DOLAR_AMERICANO" },
  { label: "EUR", value: "EURO" },
];

export const booleanOptions = [
  { label: "SI", value: 1 },
  { label: "NO", value: 0 },
];
